import { motion } from 'framer-motion';
import { Play, Pause } from 'lucide-react';
import { usePlayer } from '@/context/PlayerContext';

const TrackCard = ({ track, artist, size = 'normal' }) => {
  const { currentTrack, isPlaying, playTrack, pauseTrack, resumeTrack } = usePlayer();
  const isCurrentTrack = currentTrack?.id === track.id;

  const handlePlay = () => {
    if (isCurrentTrack) {
      isPlaying ? pauseTrack() : resumeTrack();
    } else {
      playTrack(track, artist);
    }
  };

  return (
    <motion.div
      whileHover={{ scale: 1.02 }}
      className={`group relative rounded-sm overflow-hidden bg-card border border-border card-hover cursor-pointer ${
        size === 'large' ? 'aspect-square' : 'aspect-video'
      }`}
      onClick={handlePlay}
      data-testid={`track-card-${track.id}`}
    >
      <img
        src={track.thumbnail || 'https://images.unsplash.com/photo-1614613535308-eb5fbd3d2c17?w=400'}
        alt={track.title}
        className="w-full h-full object-cover"
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
        <motion.div
          whileHover={{ scale: 1.1 }}
          className="w-14 h-14 rounded-full bg-primary flex items-center justify-center glow-purple"
        >
          {isCurrentTrack && isPlaying ? (
            <Pause size={24} className="text-white" />
          ) : (
            <Play size={24} className="text-white ml-1" />
          )}
        </motion.div>
      </div>

      {/* Info */}
      <div className="absolute bottom-0 left-0 right-0 p-4 gradient-scrim">
        <p className="font-heading font-bold text-lg truncate">{track.title}</p>
        <p className="text-sm text-muted-foreground truncate">{artist?.name || 'Unknown Artist'}</p>
      </div>

      {/* Playing indicator */}
      {isCurrentTrack && (
        <div className="absolute top-3 right-3">
          <div className={`w-3 h-3 rounded-full ${isPlaying ? 'bg-secondary animate-pulse' : 'bg-primary'}`} />
        </div>
      )}
    </motion.div>
  );
};

export default TrackCard;
